currentuser.onUserLoad( (e) => {
  let userinfos = e.detail.userinfos;
  let userbookmarks = e.detail.bookmarks;

  console.log( 'Bookmarks : init', userinfos, userbookmarks );

  [... document.querySelectorAll('.link-bookmark')].map( bookmarkEl => {

    let bookmarkElement = bookmarkEl;

    if( userinfos.loggedin ){
      if( userbookmarks.includes( bookmarkElement.dataset.contentobjectid ) ){
        bookmarkElement.dataset.bookmark = 1;
        bookmarkElement.innerHTML = 'Retirer de votre sélection';
      }
    }

    bookmarkElement.addEventListener('click', function(e){
      e.preventDefault();

      if( !userinfos.loggedin ){
        if(!bookmarkElement.closest('.bookmark').parentElement.querySelector('.login-bookmark')){
          let loginBookmark = document.createElement( 'div' );
          let bookmark = bookmarkElement.closest('.bookmark');
          loginBookmark.classList.add("login-bookmark");
          loginBookmark.innerHTML = 'Pour mettre dans votre sélection veuillez vous <a href="/compte/inscripption">inscrire</a> ou vous <a href="#" class="login-link">connecter</a>';
          bookmark.after(loginBookmark);
        }
      }
      else{
        let contentobjectid = this.dataset.contentobjectid;
        actionbookmark( contentobjectid, bookmarkElement );
      }

      return false;
    });
  });

  async function actionbookmark( contentobjectid, elt ){
    return new Promise((resolve, reject) => {

      return fetch( '/compte/add-bookmark', {
        cache: "no-store",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          contentobject_id: contentobjectid,
          bookmark: elt.dataset.bookmark
        }),
      } ).then( (response) => {
        return response.json();
      }).then( (dataresponse) => {
        if( dataresponse.success ){
          if(!dataresponse.is_bookmark){
            if(elt.classList.contains('mycontents')){
              elt.closest('.block-mycontents').remove();

              let mycontentstotal = document.querySelectorAll('.block-mycontents').length;

              if(mycontentstotal == 0){
                let alert = document.createElement('div');
                alert.classList.add('alert');
                alert.classList.add('alert-danger');
                alert.innerHTML = "Vous n'avez pas encore sauvegardé d'articles<br/><br/>Pour conserver dans votre espace vos articles préférés, il vous suffit de cliquer sur le bouton \"Ajouter à ma sélection\".";
                document.getElementById('mescontenus').append(alert);
              }
            }
            else{
              elt.dataset.bookmark = 0;
              elt.innerHTML = '<svg class="bookmark" xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px"><path d="M200-120v-640q0-33 23.5-56.5T280-840h400q33 0 56.5 23.5T760-760v640L480-240 200-120Zm80-122 200-86 200 86v-518H280v518Zm0-518h400-400Z"/></svg> Ajouter à ma sélection';
            }
          }
          else{
            elt.dataset.bookmark = 1;
            elt.innerHTML = 'Retirer de votre sélection';
          }

          resolve();
        } else {
          reject( sondageresponse.message );
        }
      }).catch( (error) => {
        reject( 'Erreur lors de l\'ajout en favori' );
      });
    });
  }
});
